import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { COUNTRIES } from "@/constants/countries";

interface CountrySelectProps {
  value?: string;
  onValueChange: (value: string) => void;
  placeholder?: string;
}

const COUNTRY_OPTIONS = (() => {
  const preferred = ["Canada", "United States"] as const;
  const sorted = COUNTRIES.slice().sort((a, b) => a.name.localeCompare(b.name));
  const preferredItems = preferred
    .map((p) => sorted.find((c) => c.name === p))
    .filter(Boolean) as Array<{ name: string }>;
  const rest = sorted.filter((c) => !preferred.includes(c.name as any));
  const ordered = [...preferredItems, ...rest];
  return ordered.map((c) => ({ value: c.name, label: c.name }));
})();

export function CountrySelect({ value, onValueChange, placeholder = "Select country" }: CountrySelectProps) {
  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger className="bg-background">
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className="bg-background border border-border shadow-lg z-50">
        {COUNTRY_OPTIONS.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
